import { Directive, Input, NgModule, OnChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[gioEnableControl]'
})
export class EnableControlsDirective implements OnChanges {

  @Input('gioEnableControl') enableControl;
  ngOnChanges() {
    const action = this.enableControl ? 'enable' : 'disable';
    this.ngControl.control[action]();
  }

  constructor(private ngControl: NgControl) { }
}

@NgModule({
  declarations: [EnableControlsDirective],
  exports: [EnableControlsDirective]
})
export class EnableControlModule { }

